/**
* @file 财务中心-发票管理
* */
<template>
  <div id="invoice">
    <custom-table ref="customTable" :customOptions="customOptions" :columns="columns" addText="机构开票权限"
                  @addFn="getAuthorityTable" addTexts="设置发票信息" @addFns="addFns">
      <template slot="table-operation">
        <el-table-column label="操作" width="100" fixed="right">
          <div slot-scope="{ row }" class="custom-action">
            <template v-if="row.status === 2">
              <el-tooltip content="查看发票" placement="top">
                <i class="iconfont icon-daochupdf" @click="viewClick(row)"></i>
              </el-tooltip>
              <el-tooltip content="重新开票" placement="top">
                <i class="iconfont icon-daizhongkai" @click="newOpen(row)"></i>
              </el-tooltip>
            </template>

            <template v-else-if="row.status === 3">
              <el-tooltip content="查看失败原因" placement="top">
                <i class="iconfont icon-shixiao" @click="reasonVisible = true; openForm = $utils.deepCopyFn(row);"></i>
              </el-tooltip>
              <el-tooltip content="重新开票" placement="top">
                <i class="iconfont icon-daizhongkai"
                   @click="openVisible = true; openForm = $utils.deepCopyFn(row);"></i>
              </el-tooltip>
            </template>
            <span v-else>-</span>
          </div>
        </el-table-column>
      </template>
      <div slot="customTable-top"
           style="display: flex;align-items: center;justify-content: space-between;padding-bottom: 16px;">
        <el-radio-group v-model="customOptions.params.status" @change="statusChange">
          <el-radio-button label="">全部</el-radio-button>
          <el-radio-button :label="item.value" v-for="item in $const.INVOICESTATUS" :key="item.value">{{ item.label }}
          </el-radio-button>
        </el-radio-group>
        <div style="display: flex; align-items: center" class="custom-switch">
          <el-switch @click.native="switchClick" disabled v-model="config" :active-value="1"
                     :inactive-value="2"></el-switch>
          <span class="util-remark" style="padding: 0 16px">开启后，乘客端将展示电子发票入口</span>
        </div>
      </div>

      <template slot-scope="{ item, row }">
        <template v-if="item.prop === 'created' || item.prop === 'billingTime'">{{
            row[item.prop] | filterTime
          }}
        </template>
        <template v-else-if="item.prop === 'status'">
          <span>{{ row[item.prop] | filterConst("INVOICESTATUS") }}</span>
        </template>
        <template v-else-if="item.prop === 'invoiceType'">
          <span>{{ row[item.prop] | filterConst("INVOICETYPE") }}</span>
        </template>
        <template v-else-if="item.prop === 'invoiceFee'">
          <span class="util-money" v-if="row.invoiceFee || row.invoiceFee === 0">{{ row.invoiceFee }}</span>
          <span v-if="!row.invoiceFee && row.invoiceFee !== 0">-</span>
        </template>
        <template v-else>{{ row[item.prop] ? row[item.prop] : "-" }}</template>
      </template>
    </custom-table>

    <!--设置发票信息弹框-->
    <el-dialog :visible.sync="visible" width="600px" :close-on-click-modal="false" @close="closeFn">
      <div slot="title">
        设置发票信息
        <p class="util-remark">请完善必填项，否则乘客将无法开票</p>
      </div>
      <el-form :model="form" :rules="rules" ref="form" label-width="110px">
        <el-form-item label="机构名称" prop="organizationId">
          <el-select @change="sourceTypeChange" v-model="form.organizationId" placeholder="请选择机构名称" filterable>
            <el-option v-for="item in authorityTable" :key="item.id" :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开票渠道" prop="sourceType">
          <el-radio-group v-model="form.sourceType" >
            <el-radio label="bw">百旺税控</el-radio>
            <el-radio disabled label="nnfp">航信税控</el-radio>
            <el-radio label="bwy">百望云数电<span style="color: red">(推荐)</span></el-radio>
          </el-radio-group>
        </el-form-item>
        <template v-if="form.sourceType === 'bwy'">

          <el-form-item label="用户名" prop="userName">
            <el-input v-model="form.userName" maxlength="30" placeholder="请输入用户名">
            </el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input v-model="form.password" maxlength="30" type="password" placeholder="请输入密码">
            </el-input>
          </el-form-item>
          <el-form-item label="发票种类编码" prop="invoiceTypeCode">
            <el-select v-model="form.invoiceTypeCode" placeholder="请选择发票种类编码" filterable>
              <el-option v-for="item in $const.INVOICETYPECODE" :key="item.value" :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="特定业务标志" prop="invoiceSpecialMark">
            <el-select v-model="form.invoiceSpecialMark" placeholder="请选择发票种类编码" filterable>
              <el-option v-for="item in $const.INVOICESPECIALMARK" :key="item.value" :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="优惠政策名称" prop="vatSpecialManagement">
            <el-select v-model="form.vatSpecialManagement" placeholder="请选择发票种类编码" filterable>
              <el-option v-for="item in $const.VATSPECIALMANAGEMENT" :key="item.value" :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="用户盐值" prop="userSalt">
            <el-input v-model="form.userSalt" maxlength="50" placeholder="请输入用户盐值">
            </el-input>
          </el-form-item>
          <el-form-item label="百望云AppId" prop="appId">
            <el-input v-model="form.appId" maxlength="30" placeholder="请输入百望云AppId">
            </el-input>
          </el-form-item>
          <el-form-item label="百望云AppKey" prop="bwyKey">
            <el-input v-model="form.bwyKey" maxlength="30" placeholder="请输入百望云AppId">
            </el-input>
          </el-form-item>
          <el-form-item label="百望云secret" prop="secret">
            <el-input v-model="form.secret"  placeholder="请输入百望云secret">
            </el-input>
          </el-form-item>
          <el-form-item label="销方税号" prop="saleTaxNum">
            <el-input v-model="form.saleTaxNum" maxlength="20" placeholder="请输入公司纳税人识别号">
            </el-input>
          </el-form-item>
          <el-form-item label="销方电话" prop="salePhone">
            <el-input v-model="form.salePhone" maxlength="20" placeholder="请输入公司电话"></el-input>
          </el-form-item>
          <el-form-item label="销方地址" prop="saleAddress">
            <el-input v-model="form.saleAddress" maxlength="30" placeholder="请输入公司地址">
            </el-input>
          </el-form-item>
          <el-form-item label="银行卡号" prop="saleAccount">
            <el-input v-model="form.saleAccount" maxlength="20" placeholder="请输入公司的银行卡号">
            </el-input>
          </el-form-item>
          <el-form-item label="销方税率" prop="taxRate">
            <el-input v-model="form.taxRate" maxlength="2" placeholder="请输入销方税率">
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
        </template>
        <template v-if="form.sourceType === 'bw' || form.sourceType === 'nnfp'">

          <el-form-item label="销方电话" prop="salePhone">
            <el-input v-model="form.salePhone" maxlength="20" placeholder="请输入公司电话"></el-input>
          </el-form-item>
          <el-form-item label="销方地址" prop="saleAddress">
            <el-input v-model="form.saleAddress" maxlength="30" placeholder="请输入公司地址">
            </el-input>
          </el-form-item>
          <el-form-item label="销方税号" prop="saleTaxNum">
            <el-input v-model="form.saleTaxNum" maxlength="20" placeholder="请输入公司纳税人识别号">
            </el-input>
          </el-form-item>
          <el-form-item label="销方税率" prop="taxRate">
            <el-input v-model="form.taxRate" maxlength="2" placeholder="请输入销方税率">
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
          <el-form-item label="银行名称" prop="saleBank">
            <el-input v-model="form.saleBank" maxlength="20" placeholder="请输入公司的银行名称">
            </el-input>
          </el-form-item>
          <el-form-item label="银行卡号" prop="saleAccount">
            <el-input v-model="form.saleAccount" maxlength="20" placeholder="请输入公司的银行卡号">
            </el-input>
          </el-form-item>
        </template>




        <!-- <template v-if="form.sourceType == 'bw'">
          <div class="util-remark" style="margin-bottom: 20px; padding-left: 20px;">以下信息由百旺提供，配置成功后请勿随意修改！</div>
          <el-form-item label="公司代码" prop="gsdm">
            <el-input v-model="form.gsdm" maxlength="50" placeholder="请输入公司代码">
            </el-input>
          </el-form-item>
          <el-form-item label="终端代码" prop="kpzddm">
            <el-input v-model="form.kpzddm" maxlength="50" placeholder="请输入终端代码">
            </el-input>
          </el-form-item>
          <el-form-item label="用户代码" prop="yhdm">
            <el-input v-model="form.yhdm" maxlength="50" placeholder="请输入用户代码">
            </el-input>
          </el-form-item>
        </template> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取 消</el-button>
        <el-button type="primary" @click="saveClick" :loading="loading">保 存</el-button>
      </span>
    </el-dialog>

    <!--重新开票弹框-->
    <el-dialog :visible.sync="openVisible" width="400px" :close-on-click-modal="false">
      <div slot="title">发票信息</div>
      <el-form :model="openForm" :rules="openRules" ref="openForm" label-width="100px">

        <el-form-item label="抬头类型" prop="invoiceType">
          <el-radio-group v-model="openForm.invoiceType">
            <el-radio v-for="item in $const.INVOICETYPE" :key="item.value" :label="item.value">{{
                item.label
              }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="公司名称" prop="companyName">
          <el-input v-model="openForm.companyName" maxlength="20" placeholder="请输入公司名称">
          </el-input>
        </el-form-item>
        <el-form-item label="公司税号" prop="companyDuty" v-if="openForm.invoiceType === 2">
          <el-input v-model="openForm.companyDuty" maxlength="20" placeholder="请输入公司纳税人识别号">
          </el-input>
        </el-form-item>
        <el-form-item label="手机号码" prop="invoicePhone">
          <el-input v-model="openForm.invoicePhone" maxlength="11" placeholder="用于接收电子发票"></el-input>
        </el-form-item>
        <el-form-item label="电子邮箱" prop="buyerEmail">
          <el-input v-model="openForm.buyerEmail" maxlength="30" placeholder="用于接收电子发票">
          </el-input>
        </el-form-item>
        <el-form-item label="真实姓名" prop="realName" v-if="form.sourceType == 'bw'">
          <el-input v-model="openForm.realName" maxlength="20" placeholder="用于接收电子发票">
          </el-input>
        </el-form-item>
        <el-form-item label="身份证号码" prop="idCard" v-if="form.sourceType == 'bw'">
          <el-input v-model="openForm.idCard" maxlength="18" placeholder="用于接收电子发票">
          </el-input>
        </el-form-item>
        <el-form-item label="公司地址" prop="companyAddress">
          <el-input v-model="openForm.companyAddress" maxlength="30" placeholder="请输入公司的地址">
          </el-input>
        </el-form-item>
        <el-form-item label="公司电话" prop="companyPhone">
          <el-input v-model="openForm.companyPhone" maxlength="15" placeholder="请输入公司的电话">
          </el-input>
        </el-form-item>
        <el-form-item label="公司开户行" prop="companyBank">
          <el-input v-model="openForm.companyBank" maxlength="30" placeholder="请输入公司的开户银行">
          </el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="openForm.remark" maxlength="80" placeholder="请输入公司的开户银行">
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="openVisible = false">取 消</el-button>
        <el-button type="primary" @click="openFormSaveClick" :loading="openLoading">确 定</el-button>
      </span>
    </el-dialog>

    <!--失败原因-->
    <el-dialog title="失败原因" :visible.sync="reasonVisible" width="400px" :close-on-click-modal="false">
      {{ openForm.errorReason }}
    </el-dialog>

    <!-- 机构开票权限列表 -->
    <el-dialog title="机构开票权限" :visible.sync="authorityVisible" width="50%" :close-on-click-modal="false">
      <div style="margin-bottom:10px; color: #FF9900;"><i class="el-icon-question util-remark"
                                                          style="font-size: 15px; padding-right: 6px;color: #FF9900;"></i>控制子机构线路是否支持电子发票，关闭后无法通过小程序开票，需配置电话让乘客联系索取发票
      </div>
      <el-table border empty-text="暂无数据" :data="authorityTable" height="500">
        <el-table-column label="机构名称" prop="fullName"></el-table-column>
        <el-table-column label="机构简称" prop="name"></el-table-column>
        <el-table-column label="机构类型" prop="type" width="100px">
          <template slot-scope="{ row }">
            <div v-if="row.type == 1">
              <el-tag size="mini">总公司</el-tag>
            </div>
            <div v-else>
              <el-tag size="mini" type="success">分公司</el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="电子发票权限" prop="invoice" v-slot="{ row }">
          <div v-if="row.type == 1">-</div>
          <el-switch v-else v-model="row.invoice" :active-value="1" :inactive-value="2"/>
        </el-table-column>
        <el-table-column label="客服电话" prop="supportPhone" v-slot="{ row }">
          <div v-if="row.type == 1">-</div>
          <el-input v-else v-model="row.supportPhone" :disabled="row.invoice == 1"
                    @input="row.supportPhone = row.supportPhone.replace(/[^\d]/g, '')" maxlength="14"
                    placeholder="请输入7-14位客服电话"/>
        </el-table-column>
      </el-table>

      <span slot="footer" class="dialog-footer">
        <el-button @click="authorityVisible = false">取 消</el-button>
        <el-button type="primary" @click="postAuthorityTable">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "invoice",
  data() {
    return {
      authorityTable: [],
      authorityVisible: false,

      openForm: {},
      openVisible: false,
      openLoading: false,

      reasonVisible: false,
      loading: false,
      form: {
        sourceType: 'bw'
      },
      rules: {
        organizationId: [{required: true, message: "请选择机构"}],
        bwType: [{required: true, message: "请选择开票模式"}],
        sourceType: [{required: true, message: "请选择开票渠道"}],
        salePhone: [
          {required: true, message: "请输入公司电话"},
          {pattern: /(^\d{7,20})|(^\d{3,4}-\d{8,})$/, message: "请输入正确的公司电话"},
        ],
        saleAddress: [{required: true, message: "请输入公司地址"}],
        saleTaxNum: [
          {required: true, message: "请输入公司纳税人识别号"},
          {min: 15, message: "请输入至少15位"},
        ],
        taxRate: [
          {required: true, message: "请输入销方税率"},
          {pattern: /^(0|[1-9][0-9]*)$/, message: "请输入正确的数字"},
        ],
        saleBank: [{message: "请输入银行名称"}],
        saleAccount: [{min: 15, message: "请输入至少15位"}],

        appId: [{required: true, message: "请输入appId"}],
        secret: [{required: true, message: "请输入百望云secret"}],
        userName: [{required: true, message: "请输入用户名"}],
        password: [{required: true, message: "请输入密码"}],
        userSalt: [{required: true, message: "请输入用户盐值"}],
        invoiceTypeCode: [{required: true, message: "请选择发票种类编码"}],
        invoiceSpecialMark: [{required: true, message: "请选择特定业务标志"}],
        vatSpecialManagement: [{required: true, message: "请选择优惠政策名称"}],
        // gsdm: [{ required: true, message: "请输入公司代码" }],
        // kpzddm: [{ required: true, message: "请输入终端代码" }],
        // yhdm: [{ required: true, message: "请输入用户代码" }],
      },
      visible: false,

      config: 2, // 开关
      // 配置项
      customOptions: {
        // 请求的列表url
        url: "/api/v1/manage/invoice",
        params: {
          status: "",
          page: 1, // 页数
          size: 20, // 每页条数
        },
        search: [
          {
            type: "input",
            field: "customerPhone",
            name: "乘客手机号",
            value: "",
          },
          {
            type: "input",
            field: "invoicePhone",
            name: "开票手机号",
            value: "",
          },
          {
            type: "input",
            field: "buyerEmail",
            name: "开票邮箱",
            value: "",
          },
          {type: "input", field: "companyName", name: "公司名称", value: ""},
          {
            type: "datetime",
            field: "created",
            name: "申请时间",
            value: [],
            dateProp: {start: "createdStart", end: "createdEnd"},
          },
          {
            type: "datetime",
            field: "billingTime",
            name: "开票时间",
            value: [],
            dateProp: {start: "billingTimeStart", end: "billingTimeEnd"},
          },
        ],
      },
      // 表头
      columns: [
        {prop: "serialNo", label: "发票流水号", width: 170},
        {prop: "status", label: "开票状态", width: 80},
        {prop: "created", label: "申请时间", width: 130},
        {prop: "customerPhone", label: "乘客手机号"},
        {prop: "realName", label: "真实姓名"},
        {prop: "idCard", label: "身份证号码", width: 150},
        {prop: "billingTime", label: "开票时间", width: 130},
        {prop: "invoiceFee", label: "开票金额", width: 70},
        {prop: "invoiceType", label: "发票类型"},
        {prop: "companyName", label: "公司名称", width: 130},
        {prop: "companyDuty", label: "公司税号", width: 130},
        {prop: "invoicePhone", label: "开票手机号"},
        {prop: "buyerEmail", label: "开票邮箱", width: 150},
        {prop: "remark", label: "备注", width: 50},
      ],
    };
  },
  computed: {
    openRules(){
      return {
        invoiceType: [{required: true, message: "请选择抬头类型"}],
        companyName: [{required: this.openForm.invoiceType === 2, message: "请输入公司名称"}],
        bwyKey: [{required: true, message: "请输入Key"}],
        companyDuty: [
          {required: true, message: "请输入公司纳税人识别号"},
          {min: 15, message: "请输入至少15位"},
        ],
        invoicePhone: [
          {required: true, message: "请输入手机号码"},
          {
            pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
            message: "请输入正确的手机号码"
          },
        ],
        buyerEmail: [{type: "email", required: true, message: "请输入正确的邮箱地址", trigger: "change"}],
        realName: [{required: true, message: "请输入姓名", trigger: "change"}],
        idCard: [
          {required: true, message: '请输入身份证号', trigger: 'blur'},
          {
            pattern: /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/,
            message: '请输入正确的身份证号',
          }
        ],
        companyPhone: [{pattern: /^\d{7,20}$/, message: "请输入正确的公司电话"}],
      }
    },
  },
  created() {
    this.getConfig();
    // this.getSales();
  },
  methods: {
    addFns() {
      this.form = {
        sourceType: 'bw',
        organizationId:this.mixinUserInfo.organizationId
      }
      this.visible = true;
      this.getAuthorityTable(false)
      this.sourceTypeChange()
    },
    closeFn(){
      this.form = {
        sourceType: 'bw',
        organizationId:this.mixinUserInfo.organizationId
      }
      this.$refs.form.clearValidate();

    },
    viewClick(row) {
      window.open(row.pdfUrls);
    },
    async getConfig() {
      let url = "/api/v1/manage/invoice/config";
      let data = await this.$axios.get(url);
      if (data && data.code === 1) {
        this.config = data.data;
      }
    },
    async postConfig() {
      let url = "/api/v1/manage/invoice/config";
      let data = await this.$axios.post(url);
      if (data && data.code === 1) {
        this.$message.success("操作成功");
        this.getConfig();
      }
    },
    switchClick() {
      if (this.config === 1) {
        this.postConfig();
      } else {
        this.$confirm(
            "开启后，乘客端将展示电子发票入口，请确认您已在我司已开通电子发票业务，如若未开通，电子发票将无法正常开票",
            "提示"
        ).then(() => {
          this.postConfig();
        });
      }
    },
    saveClick() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.loading = true;
          let url = "/api/v1/manage/invoice/sales";
          let params = this.$utils.deepCopyFn(this.form);
          let data = await this.$axios.post(url, {
            ...params

          });
          this.loading = false;
          if (data && data.code === 1) {
            this.visible = false;
            this.$message.success("操作成功");
          }
        } else {
          this.$message.warning("请检查表单数据是否输入正确！");
          return false;
        }
      });
    },
    openFormSaveClick() {
      this.$refs.openForm.validate(async (valid) => {
        if (valid) {
          this.openLoading = true;
          let url = "/api/v1/manage/invoice/again";
          let params = this.$utils.deepCopyFn(this.openForm);
          let data = await this.$axios.post(url, params);
          this.openLoading = false;
          if (data && data.code === 1) {
            this.$refs.customTable.listFn();
            this.openVisible = false;
            this.$message.success("操作成功");
          }
        } else {
          this.$message.warning("请检查表单数据是否输入正确！");
          return false;
        }
      });
    },
    /* 获取发票设置 */
    async getSales() {
      let url = "/api/v1/manage/invoice/sales";
      let data = await this.$axios.get(url);
      if (data && data.code === 1) {
        this.form = {...this.form, ...data.data} || {};
      }
    },
    /* 获取选中开票渠道的发票配置 */
    async sourceTypeChange() {
      if (!this.form.organizationId){
         return
      }
      this.form= {
        organizationId: this.form.organizationId,
        sourceType: this.form.sourceType
      }
      let url = "/api/v1/manage/invoice/sales";
      let data = await this.$axios.get(url, {organizationId: this.form.organizationId});
      if (data && data.code === 1) {
        this.form = {...this.form, ...data.data} || {};
      }
      this.$refs.form.clearValidate();
    },
    /* 状态改变 */
    statusChange() {
      this.customOptions.params.page = 1;
      this.$refs.customTable.listFn();
    },
    newOpen(row) {
      if (row.isReopen === 1) {
        this.$message.warning("该发票已重开过，无法再次申请重开");
      } else {
        this.openVisible = true;
        this.openForm = this.$utils.deepCopyFn(row);
      }
    },
    async getAuthorityTable(type = true) {
      let url = "/api/v1/manage/invoice/authority/list";
      let data = await this.$axios.get(url);
      if (data && data.code === 1) {
        if (type) {
          this.authorityTable = data.data;
        } else {
          this.authorityTable = data.data.filter(item => item.invoice == 1);
        }

        this.authorityVisible = type;
      }
    },
    async postAuthorityTable() {
      let bl = false;
      for (let index = 0; index < this.authorityTable.length; index++) {
        if (this.authorityTable[index].invoice == 2) {
          if (!this.authorityTable[index].supportPhone) {
            this.$message.info('请填写机构客服电话，方便乘客索取发票');
            bl = true;
            break;
          } else if (!this.authorityTable[index].supportPhone.match(/^[-\d]{7,14}$/)) {
            this.$message.info('请输入7-14位的联系方式');
            bl = true;
            break;
          }
        }
        if (this.authorityTable[index].supportPhone && !this.authorityTable[index].supportPhone.match(/^[-\d]{7,14}$/)) {
          this.$message.info('请输入7-14位的联系方式');
          bl = true;
          break;
        }
      }
      if (bl) return;

      let url = "/api/v1/manage/invoice/authority";
      let data = await this.$axios.put(url, {organizationDetails: JSON.stringify(this.authorityTable)});
      if (data && data.code === 1) {
        this.authorityVisible = false;
        this.$message.success('保存成功');
      }
    },
  }
};
</script>
